export const GET_TASKS_DATA = 'get_tasks_data';
export const GET_SUBJECTDETAIL_DATA = 'get_subjectDetail_data';
export const GET_PAGE_STATE = 'get_page_state'; // 获取页面状态
